const IMAGE_SIZES = {
  gallery: {
    '1x': { w: 800, h: 500 },
    '2x': { w: 1600, h: 1000 },
  },
  galleryThumb: {
    '1x': { w: 64, h: 40 },
    '2x': { w: 128, h: 80 },
  },
  galleryThreeSixty: {
    '1x': { w: 960, h: 540 },
    '2x': { w: 1600, h: 900 },
  },
  productModal: {
    '1x': { w: 500, h: 500 },
    '2x': { w: 1000, h: 1000 },
  },
  productTile: {
    '1x': { w: 160, h: 160 },
    '2x': { w: 320, h: 320 },
  },
  accordionProductTile: {
    '1x': { w: 50, h: 50 },
    '2x': { w: 100, h: 100 },
  },
  cartProductTile: {
    '1x': { w: 110, h: 110 },
    '2x': { w: 220, h: 220 },
  },
  cartSoftwareTile: {
    '1x': { w: 32, h: 32 },
    '2x': { w: 64, h: 64 },
  },
};

const contentfulImageUrl = ({ baseUrl, w, h, fm = 'jpg', q = 90 }) => {
  const queryParams = new URLSearchParams({
    w,
    h,
    q,
    fm,
  });

  return `${baseUrl}?${queryParams}`;
};

const shopImageUrl = ({ baseUrl, type, size = '1x', fm = 'jpg', q = 90 }) => {
  if (!IMAGE_SIZES[type] || !IMAGE_SIZES[type][size]) {
    return null;
  }

  return contentfulImageUrl({ baseUrl, fm, q, ...IMAGE_SIZES[type][size] });
};

const shopImageSrcSet = ({ baseUrl, type, fm = 'jpg', q = 90 }) => {
  if (!IMAGE_SIZES[type]) {
    return null;
  }

  const oneX = shopImageUrl({ baseUrl, type, fm, q, size: '1x' });
  const dosEquis = shopImageUrl({ baseUrl, type, fm, q, size: '2x' });

  return `${oneX} 1x, ${dosEquis} 2x`;
};

export { IMAGE_SIZES, contentfulImageUrl, shopImageUrl, shopImageSrcSet };
